import { FAILED, LOADING, SUCCESS, CLEAR_MESSAGE, RESET } from './constants';

export const initialState = {
  dataProducts: [],
  dataProductPrices: {
    products: [],
  },
  dataProductPriceLists: {
    data: [],
    meta: { page: 1, totalData: 0, totalPage: 0 },
  },
  dataSubUserProductPriceLists: {
    data: [],
    meta: { page: 1, totalData: 0, totalPage: 0 },
  },
  dataFilter: {
    regionalId: '',
    provinceId: '',
    cityId: '',
  },
  dataSubUserFilter: {
    regionalId: '',
    provinceId: '',
    cityId: '',
    districtId: '',
    villageId: '',
  },
  dataSubmitProductPrices: false,
  dataSubmitSubUserProductPrices: false,
  dataSearchSubUserByRegistrationId: {},
  dataEditSubUserProductPricesBySubUserId: false,
  dataUploadUpdatePrice: {},
  dataUploadUpdatePriceSubUser: [],
  dataTemplateHet: {},
  isLoadingProductPrices: false,
  isLoadingProductPriceLists: false,
  isLoadingProducts: false,
  isLoadingSubmitProductPrices: false,
  isLoadingSubmitSubUserProductPrices: false,
  isLoadingSearchSubUserByRegistrationId: false,
  isLoadingEditSubUserProductPricesBySubUserId: false,
  isLoadingUploadUpdatePrice: false,
  isLoadingUploadUpdatePriceSubUser: false,
  isLoadingTempateHet: false,
  isLoadingSubUserProductPriceLists: false,
  messageProductPrices: '',
  messageProductPriceLists: '',
  messageSubmitProductPrices: '',
  messageSubmitSubUserProductPrices: '',
  messageSearchSubUserByRegistrationId: '',
  messageEditSubUserProductPricesBySubUserId: '',
  messageUploadUpdatePrice: '',
  messageUploadUpdatePriceSubUser: '',
  messageTemplateHet: '',
  messageSubUserProductPriceLists: '',
};

export default function reducer(state = initialState, action) {
  const { type, data, isLoading, message, key } = action;

  switch (type) {
    case FAILED:
      return {
        ...state,
        [`data${key}`]: initialState[`data${key}`],
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case LOADING:
      return {
        ...state,
        [`isLoading${key}`]: isLoading,
        [`message${key}`]: '',
      };
    case SUCCESS:
      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: '',
      };
    case CLEAR_MESSAGE:
      return {
        ...state,
        [`message${key}`]: '',
      };
    case RESET:
      return {
        ...state,
        [`data${key}`]: initialState[`data${key}`],
        [`isLoading${key}`]: initialState[`isLoading${key}`],
        [`message${key}`]: initialState[`message${key}`],
      };
    default:
      return state;
  }
}
